import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";
import {APP, GAME_STATUSES} from "../../app/consts";
import {ROUTE_NAMES} from "../../consts";

export class PredictionClickEvent extends ClickEvent {
  gameId: Number;
  competitionId: Number;
  status: GAME_STATUSES;
  currentLinkModelName: ROUTE_NAMES;
  screen: ROUTE_NAMES;
  selection: Number;
  marketType: Number;
  hasOdds: Boolean;
  hasInsight: Boolean;
  isContextual: Boolean;
  contextualUsed: Boolean;

  constructor(params: PredictionClickEvent) {
    super('', 'click', 'prediction');

    this.currentLinkModelName = params.currentLinkModelName;
    this.source = params.source;
    this.subSource = params.subSource;
    this.gameId = params.gameId;
    this.competitionId = params.competitionId;
    this.status = params.status;
    this.selection = params.selection;
    this.marketType = params.marketType;
    this.hasOdds = params.hasOdds;
    this.hasInsight = params.hasInsight;
    this.isContextual = params.isContextual;
    this.contextualUsed = params.contextualUsed;
    this.screen = params.screen;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.source = this.source;
    properties.subSource = this.subSource;
    properties.screen = APP.ANALYTICS.SOURCES[this.currentLinkModelName];
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.competitionId = this.competitionId;
    properties.selection = this.selection;
    properties.marketType = this.marketType;
    properties.isOdds = this.hasOdds;
    properties.isInsight = this.hasInsight;
    properties.isContextual = this.isContextual;
    properties.contextualUsed = Number(this.contextualUsed);
    properties.screen = this.screen;

    return properties;
  }
}
